import { useTranslation } from 'react-i18next';

import { tList } from '../../../utils/t-list';
import { Stepper } from '../../common/Stepper';
import type { CardGenFlowState } from './CardGenerator.flow';
import { cardGenErrorStep, cardGenStep } from './CardGenerator.flow';

/** Where the generator is: template · recipients · output · review · run. */
export function CardGenStepper(flow: CardGenFlowState) {
  const { t } = useTranslation();
  return (
    <Stepper
      steps={tList(t, 'cards.steps')}
      current={cardGenStep(flow)}
      errorStep={cardGenErrorStep(flow)}
    />
  );
}
